export const slugifyClient = (text) => (text || '').toString().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

export const categoryPath = (cat) => `/pieces/${typeof cat === 'string' ? cat : cat?.slug || ''}`;

const subSlug = (cat, name) => (cat?.subcategory_slugs || {})[name] || slugifyClient(name);

// --- 3-level tree: `subcategory_parents` = { childName: parentName } (sub-categories stay a flat list)
export const parentOf = (cat, name) => (name && cat?.subcategory_parents?.[name]) || '';
export const childrenOf = (cat, name) => (cat?.subcategories || []).filter(s => cat?.subcategory_parents?.[s] === name);
export const topSubcategories = (cat) => (cat?.subcategories || []).filter(s => !cat?.subcategory_parents?.[s]);
export const hasChildren = (cat, name) => childrenOf(cat, name).length > 0;
// node + its children (products of a level-2 page include its level-3 children)
export const nodeNames = (cat, name) => [name, ...childrenOf(cat, name)];
// "Parent › Enfant" label for admin lists
export const subFullLabel = (cat, name) => (parentOf(cat, name) ? `${parentOf(cat, name)} › ${name}` : name);

export const subcategoryPath = (cat, subName) => {
  const parent = parentOf(cat, subName);
  return parent ? `${categoryPath(cat)}/${subSlug(cat, parent)}/${subSlug(cat, subName)}` : `${categoryPath(cat)}/${subSlug(cat, subName)}`;
};

export const subcategoryFromSlug = (cat, slug, childSlug) => {
  if (!cat || !slug) return '';
  const node = (cat.subcategories || []).find(s => subSlug(cat, s) === slug) || '';
  if (!childSlug) return node;
  const child = (cat.subcategories || []).find(s => subSlug(cat, s) === childSlug) || '';
  return node && child && parentOf(cat, child) === node ? child : '';
};
